import { Array, String, Record, Union, Null } from "runtypes";

export const Purchase = Record({
  id: String,
  objectId: String,
  objectType: String,
  objectName: String,
  creationDate: String,
  paymentDate: Union(String, Null),
  paymentProcessorTransactionId: Union(String, Null),
  downloadUrl: Union(String, Null),
  objectLogoUrl: Union(String, Null),
});

export const AdminPurchase = Record({
  id: String,
  userId: String,
  userName: String,
  userEmail: Union(String, Null),
  objectId: String,
  objectType: String,
  objectName: String,
  objectLogoUrl: Union(String, Null),
  creationDate: String,
  paymentDate: Union(String, Null),
  paymentProcessorTransactionId: Union(String, Null),
  downloadUrl: Union(String, Null),
});

// The response is an array of purchases
export const UserPurchasesResponse = Array(Purchase);
export const AdminPurchasesResponse = Array(AdminPurchase);
